import { useHistory } from "react-router-dom";

const DashboardIntegrated = ({ language, token }) => {
  const history = useHistory();
  const newDashboardIframe = "https:" +
  window.process.env.URL_Media + "/dashboard" +
    "?lang=" +
    language +
    "&token=" +
    token ;
  window.addEventListener(
    "message",
    function (event) {
      const parentUrl = window.parent.location.href;
      if (event.data.event === "changeRoute") {
        let newUrl;
        if (parentUrl.includes("/dashboard")) {
          newUrl = parentUrl.replace(
            "/dashboard",
            event.data.data
          );
        } else {
          newUrl = parentUrl.concat(event.data.data.slice(1));
        }
        window.parent.location.href = newUrl;
      } else if (event.data?.info === "edit_live") {
        window.parent.location.href = parentUrl.includes("/dashboard")
          ? parentUrl.replace(
              "/dashboard",
              `/media/lives?id=${event.data.value}`
            )
          : `${parentUrl}media/lives?id=${event.data.value}`;
      } else if (event.data?.info === "editPlaylist") {
        history.push({
          pathname: "/media/playlist",
          state: { id: event.data?.value },
        });
      }else if (event.data?.info === "edit_video") {
        history.push({
          pathname: "/media/video",
          state: { id: event.data?.value,filename: event.data?.filename },
        });
      }
      else if (event.data?.info === "edit_podcast") {
        history.push({
          pathname: "/media/podcast",
          state: { id: event.data?.value },
        });
      }
    },
    false
  );

  return (
    <iframe
      id="iframe_dashboard_display"
      src={newDashboardIframe}
      allowFullScreen
      frameBorder={"0"}
      style={{ width: "100%", height: "98%", overflow: "hidden" }}
    />
  );
};

export default DashboardIntegrated;
